import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import {
	provideHttpClient,
	withInterceptorsFromDi,
} from '@angular/common/http';
import {
	provideRouter,
	withPreloading,
	PreloadAllModules,
} from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { register as registerSwiper } from 'swiper/element/bundle';

registerSwiper();

bootstrapApplication(AppComponent, {
	providers: [
		provideRouter(routes, withPreloading(PreloadAllModules)),
		provideHttpClient(withInterceptorsFromDi()),
	],
}).catch((err) => console.error(err));
